import { createStore } from "zustand";
import { combine } from "zustand/middleware";

import { createStoreGetters } from "./root";

export function createConfigStore() {
  return createStore(
    combine({}, (_set, _get) => {
      return {
        async init() {},
        env: {
          APP_ENV: import.meta.env.VITE_APP_ENV as "dev" | "test" | "preview" | "prod",
          CAP_SRV_API_URL: import.meta.env.VITE_CAP_SRV_API_URL,
          WEB_CORE_API_URL: import.meta.env.VITE_WEB_CORE_API_URL,
          FILE_UPLOAD_API_URL: import.meta.env.VITE_FILE_UPLOAD_API_URL,

          STRIPE_PUBLISHABLE_LIVE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_LIVE_KEY,
          STRIPE_PUBLISHABLE_TEST_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_TEST_KEY,

          INTERCOM_APP_ID: import.meta.env.VITE_INTERCOM_APP_ID,

          // injected by Cloudflare Pages + build commands
          COMMIT_SHA: import.meta.env.VITE_CF_PAGES_COMMIT_SHA ?? "unknown",
          BRANCH: import.meta.env.VITE_CF_PAGES_BRANCH ?? "unknown",
        },
      };
    })
  );
}

type ConfigStore = ReturnType<ReturnType<typeof createConfigStore>["getState"]>;

export const {
  getStore: getConfigStore,
  getStoreAsync: getConfigStoreAsync,
  getStoreApi: getConfigStoreApi,
} = createStoreGetters<ConfigStore>("config");
